export const agentQueries = {
  get: (sessionId: string, agentId: string) => ["agent", sessionId, agentId],
};
